import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  // This styles are related to the card inside the /cart, where you check
  // the items you have on the cart
  cart: {
    padding: "20%",
    backgroundColor: "white",
    // backgroundColor: "#fff5e772",
    maxWidth: "100%", //this 100% will take the max space available, knowing that the grid is at lg={6}
    margin: "1% auto 3% auto",
    transition: "0.3s",

    boxShadow: "-13px -13px 0px -4px rgba(0, 0, 0, 0.75)",
    border: "3px solid #121212",
    borderRadius: "111px 111px 111px 111px",
    color: "#fff",
    //
    // backgroundImage: `linear-gradient(#00ffb3 0.5px, transparent 0.5px), linear-gradient(to right, #00ffb3 0.5px, transparent 0.5px)`,
    // backgroundSize: "39px 39px",
    // backgroundColor: "#ffffff",
    //
    //

    [theme.breakpoints.up("xs")]: {
      // backgroundColor: "yellow",
      padding: "10% 7% 10% 7%",
      borderRadius: "50px",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "#eee",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "#f0f",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
    },
    //
    //
    //
  },
  media: {
    height: 0,
    border: "3px solid #121212",
    borderRadius: "100px",

    [theme.breakpoints.up("xs")]: {
      // backgroundColor: "yellow",
      padding: "40% 7% 20% 7%",
      marginBottom: "30px",
      borderRadius: "50px",
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
    },
  },
  cartContent: {
    display: "flex",
    justifyContent: "center",
  },
  //
  //
  // ***  NAME
  productName: {
    color: "#121212",
    letterSpacing: "1px",
    fontFamily: "RobotoBlack",
    fontWeight: "100",
    opacity: "0.8",
    margin: "0.8em 0 0.3em 0",
    [theme.breakpoints.up("xs")]: {
      // backgroundColor: "yellow",
      fontSize: `calc(13px + 1.1vmin)`,
      lineHeight: `calc(16px + 1.1vmin)`,

      //
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
      fontSize: `calc(10px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
    },
  },
  //
  //
  // *** PRICE
  productPrice: {
    color: "#121212",
    fontFamily: "PoppinsThin",
    fontWeight: "600",

    opacity: "0.8",
    margin: "0 0 0.3em 0",

    [theme.breakpoints.up("xs")]: {
      // backgroundColor: "yellow",
      fontSize: `calc(9px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
      letterSpacing: "2px",
      //
    },
    [theme.breakpoints.up("sm")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("md")]: {
      // backgroundColor: "red",
    },
    [theme.breakpoints.up("lg")]: {
      // backgroundColor: "salmon",
      fontSize: `calc(7px + 1.1vmin)`,
      lineHeight: `calc(8px + 1.1vmin)`,
      letterSpacing: "2px",
    },
  },

  //
  //
  //
  cartActions: {
    justifyContent: "space-between",
    color: "#121212",
  },
  // decrease and increase + & -
  buttons: {
    display: "flex",
    alignItems: "center",

    // somehow the color red to the btns here dont work, so go to jsx and modify it there. CartItem.jsx
  },
  BtnsIncreaseDecrease: {
    fontSize: "1rem",

    width: "20px",
    height: "20px",
    color: "#121212",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  // BUTTON REMOVES
  buttonRemoves: {
    padding: "0.7em 1.6em",
    backgroundColor: "transparent",
    color: "#121212",
    //
    borderTop: "0.8px dotted #121212",
    borderBottom: "0.8px dotted #121212",
    borderLeft: "0 none",
    borderRight: "0 none",
    //
    boxShadow: "none",
    //
    borderRadius: "0",
    transition: "all 0.6s ease-in-out",
    "&:hover": {
      //
      borderTop: "0.8px dotted #121212",
      borderBottom: "0.8px dotted #121212",
      borderRadius: "100px",
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "#121212",
      // fontStyle: "italic",
      // fontWeight: "600",
    },
  },
}));

/*

  boxShadow: "0 8px 10px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 15px -12.125px rgba(0,0,0,0.3)",
    },


*/
